import React, { FC, useEffect, useState } from 'react';
import Form from '../../../components/Form/Form';
// import { BranchFormWrapper, BranchFormBox } from './styled';
import { useQuery } from '@apollo/client';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { FORM_PAGES } from '../../../components/Form/types';
// import Header from '../../../components/Header/BranchHeader';
import Header from '../../../components/Header/ProviderHeader';
import Layout from '../../../components/Layout/Layout';
import LoadingSpinner from '../../../components/Shared/LoadingSpinner/LoadingSpinner';
import useColorTheme from '../../../hooks/useColorTheme';
import { vars } from '../../../reactive';
import { setFormPage } from '../../../reactive/actions';
import { GetBranchById } from '../../../utils/queries';
import { ProviderFormBox, ProviderFormWrapper } from '../../Providers/ProviderForm/styled';

const BranchForm: FC<{
  authLoading: boolean;
  branch: Record<string, unknown>;
  isLocalStorageSupported: boolean;
}> = ({ authLoading, branch, isLocalStorageSupported }) => {
  const [visible, setVisible] = useState(false);
  const ID_FROM_URL = branch.id;
  const { data, loading } = useQuery(GetBranchById, {
    variables: { id: ID_FROM_URL },
    fetchPolicy: 'cache-and-network'
  });

  const { i18n } = useTranslation();

  const currentBranch = data?.getBranchById;

  useEffect(() => {
    vars.currentProvider(null);
    if (data?.getBranchById && isLocalStorageSupported && !loading) {
      vars.currentBranch(data?.getBranchById);
      vars.isProviderView(false);
      vars.isFormFillView(false);
      setVisible(true);
    }
  }, [data, isLocalStorageSupported, loading]);

  const primaryColor = currentBranch?.colors?.primary;

  useColorTheme(primaryColor);

  useEffect(() => {
    if (isLocalStorageSupported) {
      setFormPage(FORM_PAGES.PRODUCTS);
    }
  }, [isLocalStorageSupported]);

  return (
    <Layout language={i18n.language}>
      <ProviderFormWrapper primaryColor={primaryColor}>
        <Header branch={currentBranch} />
        <ProviderFormBox primaryColor={primaryColor}>
          {((!currentBranch && loading) || authLoading) && <LoadingSpinner />}
          {currentBranch && !authLoading && visible && <Form />}
        </ProviderFormBox>
        {/* <Footer /> */}
      </ProviderFormWrapper>
    </Layout>
  );
};

export default BranchForm;
